import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const textFilesService = {}
const apiRoute = '/home';

textFilesService.getAll = async function (query = '') {
    try {
        const res = await fetch({
            url: `${apiRoute}/getTxt/public`,
            method: 'get'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
        return err
    }
}



export default textFilesService;